export const requestAndApplyFilter = (params, resdata) => {
  if (resdata) {
    if (resdata.mapComuneIstatNumberToKPIValue) {
      applyFilter(params, params.allJsons.comune.propertyName, aggregate(resdata));
    } else {
      console.log("Invalid data returned from server", resdata);
      resetFilter(params);
    }
  } else {
    resetFilter(params);
  }
};

const resetFilter = (params) => {
  params.setGeojsonDataComunePointsFiltered(params.geojsonDataComunePoints);
  params.setGeojsonDataComunePolygonsFiltered(params.geojsonDataComunePolygons);
  params.setGeojsonDataProvPointsFiltered(params.geojsonDataProvPoints);
  params.setGeojsonDataProvPolygonsFiltered(params.geojsonDataProvPolygons);
  params.setGeojsonDataRegionePointsFiltered(params.geojsonDataRegionePoints);
  params.setGeojsonDataRegionePolygonsFiltered(params.geojsonDataRegionePolygons);
};

const comuneNrToProvNr = (communeNr) => {
  return parseInt(communeNr.slice(0, -3)); // Remove last 3 digits
};

const tableOfProvinces = {
  // From https://www.istat.it/storage/codici-unita-amministrative/Elenco-comuni-italiani.csv, columns 0 and 2.
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  96: 1,
  103: 1,
  7: 2,
  12: 3,
  13: 3,
  14: 3,
  15: 3,
  16: 3,
  17: 3,
  18: 3,
  19: 3,
  20: 3,
  97: 3,
  98: 3,
  108: 3,
  21: 4,
  22: 4,
  23: 5,
  24: 5,
  25: 5,
  26: 5,
  27: 5,
  28: 5,
  29: 5,
  30: 6,
  31: 6,
  32: 6,
  93: 6,
  8: 7,
  9: 7,
  10: 7,
  11: 7,
  33: 8,
  34: 8,
  35: 8,
  36: 8,
  37: 8,
  38: 8,
  39: 8,
  40: 8,
  99: 8,
  45: 9,
  46: 9,
  47: 9,
  48: 9,
  49: 9,
  50: 9,
  51: 9,
  52: 9,
  53: 9,
  100: 9,
  54: 10,
  55: 10,
  41: 11,
  42: 11,
  43: 11,
  44: 11,
  109: 11,
  56: 12,
  57: 12,
  58: 12,
  59: 12,
  60: 12,
  66: 13,
  67: 13,
  68: 13,
  69: 13,
  70: 14,
  94: 14,
  61: 15,
  62: 15,
  63: 15,
  64: 15,
  65: 15,
  71: 16,
  72: 16,
  73: 16,
  74: 16,
  75: 16,
  110: 16,
  76: 17,
  77: 17,
  78: 18,
  79: 18,
  80: 18,
  101: 18,
  102: 18,
  81: 19,
  82: 19,
  83: 19,
  84: 19,
  85: 19,
  86: 19,
  87: 19,
  88: 19,
  89: 19,
  90: 20,
  91: 20,
  92: 20,
  95: 20,
  104: 20,
  105: 20,
  106: 20,
  107: 20,
  111: 20,
};

const aggregate = (filterData) => {
  const filterByComune = filterData.mapComuneIstatNumberToKPIValue;

  const filterByProvince = Object.entries(filterByComune).reduce((acc, [key, value]) => {
    const provNr = comuneNrToProvNr(key);
    acc[provNr] = (acc[provNr] || 0) + value;
    return acc;
  }, {});

  const filterByRegione = Object.entries(filterByProvince).reduce((acc, [key, value]) => {
    const regionNr = tableOfProvinces[key];
    acc[regionNr] = (acc[regionNr] || 0) + value;
    return acc;
  }, {});

  const retVal = { comune: filterByComune, prov: filterByProvince, regione: filterByRegione };
  return retVal;
};

const applyFilter = (params, propertyName, filterResult) => {
  {
    const newGeojsonDataPoints = {
      ...params.geojsonDataComunePoints,
      features: params.geojsonDataComunePoints.features.map((feature) => ({
        ...feature,
        properties: getUpdatedPropertiesForComune(feature, propertyName, filterResult),
      })),
    };
    params.setGeojsonDataComunePointsFiltered(newGeojsonDataPoints);

    const newGeojsonDataPolygon = {
      ...params.geojsonDataComunePolygons,
      features: params.geojsonDataComunePolygons.features.map((feature) => ({
        ...feature,
        properties: getUpdatedPropertiesForComune(feature, propertyName, filterResult),
      })),
    };
    params.setGeojsonDataComunePolygonsFiltered(newGeojsonDataPolygon);
  }

  {
    const newGeojsonDataPoints = {
      ...params.geojsonDataProvPoints,
      features: params.geojsonDataProvPoints.features.map((feature) => ({
        ...feature,
        properties: getUpdatedPropertiesForProv(feature, propertyName, filterResult),
      })),
    };
    params.setGeojsonDataProvPointsFiltered(newGeojsonDataPoints);

    const newGeojsonDataPolygon = {
      ...params.geojsonDataProvPolygons,
      features: params.geojsonDataProvPolygons.features.map((feature) => ({
        ...feature,
        properties: getUpdatedPropertiesForProv(feature, propertyName, filterResult),
      })),
    };
    params.setGeojsonDataProvPolygonsFiltered(newGeojsonDataPolygon);
  }

  {
    const newGeojsonDataPoints = {
      ...params.geojsonDataRegionePoints,
      features: params.geojsonDataRegionePoints.features.map((feature) => ({
        ...feature,
        properties: getUpdatedPropertiesForRegione(feature, propertyName, filterResult),
      })),
    };
    params.setGeojsonDataRegionePointsFiltered(newGeojsonDataPoints);

    const newGeojsonDataPolygon = {
      ...params.geojsonDataRegionePolygons,
      features: params.geojsonDataRegionePolygons.features.map((feature) => ({
        ...feature,
        properties: getUpdatedPropertiesForRegione(feature, propertyName, filterResult),
      })),
    };
    params.setGeojsonDataRegionePolygonsFiltered(newGeojsonDataPolygon);
  }
};

// Which properties to update:
// comune :  "PRO_COM": 58091, "no_contratti": 4
// prov :  "COD_PROV": 58 (not "COD_UTS": 258)
// regione : "COD_REG": 20

const getUpdatedPropertiesForComune = (feature, propertyName, filterResult) => {
  return {
    ...feature.properties,
    [propertyName]: filterResult.comune[feature.properties.PRO_COM] || 0,
  };
};

const getUpdatedPropertiesForProv = (feature, propertyName, filterResult) => {
  return {
    ...feature.properties,
    [propertyName]: filterResult.prov[feature.properties.COD_PROV] || 0,
  };
};

const getUpdatedPropertiesForRegione = (feature, propertyName, filterResult) => {
  const retval = {
    ...feature.properties,
    [propertyName]: filterResult.regione[feature.properties.COD_REG] || 0,
  };
  return retval;
};
